export default __webpack_public_path__ + "static/media/Smaltarme_klippet.474df45b.mp4";